import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import axios from 'axios';
import config from '../config';
import { carrierOptions, planRateType, incorporationState, planRule, insuranceType } from '../utils/DropDownOptions';
import { format } from 'date-fns';

function PlanDetails({ oldPlanData, planData, planLabels, coverageType, caseId, onError = () => { } }) {
    const [Divisions, setDivisions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCobraGroups = async () => {
            try {
                const response = await axios.get(`${config.API_URL}/CobraGroups/GetCobraGroupsByCaseId/${caseId}`);

                setDivisions(response.data || []);


            } catch (error) {
                if (error.response?.status !== 404) {
                    setError('Error fetching files.');
                }
                onError(error);
            } finally {
                setLoading(false);
            }
        };
        fetchCobraGroups();
    }, [caseId]);




    if (!planData.length) return null;

    const parseDate = (dateString) => {
        if (!dateString) return null;
        const year = parseInt(dateString.slice(0, 4), 10);
        const month = parseInt(dateString.slice(4, 6), 10) - 1; // Month is 0-indexed
        const day = parseInt(dateString.slice(6, 8), 10);
        return new Date(year, month, day).toLocaleDateString(); // Format date for display
    };



    const getLabelForValue = (value, options) => {
        const option = options.find(opt => opt.value === value);
        return option ? option.label : '-';
    };

    const renderDivisions = (selectedDivisions) =>
        selectedDivisions.map((division) => division.employeeGroupName).join(', ');


    return (
        <Col lg={12} className="mb-3">
            <Card>
                <Card.Body>

                    <div className="collapsible-btn plan-collapsible-btn mx-auto d-block">
                        <Card.Title>{planLabels.title}</Card.Title>
                    </div>




                    {planData.map((plan, index) => (
                        <div className="collapsible">
                            <div className="mx-auto d-block">
                                <strong>{plan.carrierName} - {plan.planName}</strong>

                            </div>
                            <div className="collapsible-content mt-3">
                                <div className="container-fluid">
                                    <Row>
                                        <Card>
                                            <div className='mb-5' key={index}>
                                                <div className="table-responsive mb-3">


                                                    <table className="styled-table table-hover mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th className="vertical-th"></th>
                                                                <th><strong>Current Plan Year</strong></th>
                                                                <th><strong>New Plan Year</strong></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <th className="" scope="row">
                                                                    Is this plan terminating?
                                                                </th>
                                                                <td>{oldPlanData.some((oldPlan) => oldPlan.planId === plan.planId.replace(/_1$/, '') &&
                                                                    oldPlan.isTerminating === 'true') ? 'Yes' : 'No'}</td>
                                                                <td>{plan.isTerminating === 'true' ? 'Yes' : 'No'}</td>
                                                            </tr>



                                                            {plan.isTerminating !== "true" && (
                                                                planLabels.fields.map((field, idx) => {
                                                                    const oldValue = oldPlanData.find((oldPlan) =>
                                                                        oldPlan.planId === plan.planId.replace(/_1$/, '')
                                                                    )?.[field.key];
                                                                    const newValue = field.key === 'divisions'
                                                                        ? plan['isDivisionSpecific'] === 'true' && Divisions.filter(division =>
                                                                            division.planId === plan.planId && division.isSelected === true
                                                                        ).length > 0
                                                                            ? renderDivisions(
                                                                                Divisions.filter(division =>
                                                                                    division.planId === plan.planId && division.isSelected === true
                                                                                )
                                                                            )
                                                                            : '-'
                                                                        : plan[field.key];


                                                                    let options = [];
                                                                    if (field.key === 'insuranceType') options = insuranceType;
                                                                    else if (field.key === 'planRule') options = planRule;
                                                                    else if (field.key === 'planRateType') options = planRateType;

                                                                    // Function to format date in mm-dd-yyyy
                                                                    const formatDate = (dateStr) => {
                                                                        if (!dateStr) return '-';
                                                                        const date = new Date(dateStr);
                                                                        return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getFullYear()}`;
                                                                    };

                                                                    return (
                                                                        <tr key={idx}>
                                                                            <th scope="row">
                                                                                {field.label}
                                                                            </th>
                                                                            <td>
                                                                                {field.key === 'insuranceType'
                                                                                    ? getLabelForValue(oldValue, insuranceType)
                                                                                    : field.key === 'planRule'
                                                                                        ? getLabelForValue(oldValue, planRule)
                                                                                        : field.key === 'planRateType'
                                                                                            ? getLabelForValue(oldValue, planRateType)
                                                                                            : field.key === 'planRenewalDate'
                                                                                                ? formatDate(oldValue)
                                                                                                : oldValue || '-'}
                                                                            </td>
                                                                            <td style={{
                                                                                backgroundColor: newValue !== oldValue ? 'yellow' : 'transparent'
                                                                            }}>
                                                                                {field.key === 'insuranceType'
                                                                                    ? getLabelForValue(newValue, insuranceType)
                                                                                    : field.key === 'planRule'
                                                                                        ? getLabelForValue(newValue, planRule)
                                                                                        : field.key === 'planRateType'
                                                                                            ? getLabelForValue(newValue, planRateType)
                                                                                            : field.key === 'planRenewalDate'
                                                                                                ? formatDate(newValue)
                                                                                                : newValue || '-'}
                                                                            </td>
                                                                        </tr>

                                                                    );
                                                                })
                                                            )}

                                                        </tbody>
                                                    </table>
                                                </div>

                                                {plan.isTerminating === "true" && (
                                                    <>
                                                        <Row>
                                                            <Col lg={6}>
                                                                <Card.Title>Plan Mapping</Card.Title>
                                                            </Col>

                                                        </Row>

                                                        <table className="table">
                                                            <thead>
                                                                <tr>
                                                                    <th>Terminating Plan</th>
                                                                    <th>Plan Mapping</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>{plan.planName}</td>
                                                                    <td>{plan?.mappedPlanName}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </>
                                                )}

                                                {plan.isTerminating !== "true" && (
                                                    <>
                                                        {(plan.planRateType === "Composite" || plan.planRateType === "UnitBased") && (

                                                            <>

                                                                {(plan.planRateType !== "UnitBased" && (plan.isRenewal === "true" || plan.isRenewal === "Yes")) && (
                                                                    <div className="table-responsive">
                                                                        <table className="styled-table mt-0 mb-3">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <th className="">
                                                                                        Are rates and/or coverage level changing?
                                                                                    </th>

                                                                                    <td className="cobra">
                                                                                        {plan.isRatesChanging === 'true' ? 'Yes' : 'No'}
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>

                                                                        </table>
                                                                    </div>

                                                                )}
                                                                <div className="row">
                                                                    <div className="col-lg-6">
                                                                        <h5 className="card-title mt-3">Rate Information</h5>
                                                                    </div>
                                                                </div>
                                                                <div className="table-responsive">
                                                                    <table className="styled-table mt-0 mb-3">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Monthly Premium Type</th>
                                                                                {(plan.planRateType !== "UnitBased" && (plan.isRenewal === "true" || plan.isRenewal === "Yes")) ? (
                                                                                    <th >
                                                                                        Current 100% Monthly Premium <br></br> (exclude 2% admin fee)

                                                                                    </th>
                                                                                ) : (plan.planRateType === "UnitBased" && (plan.isRenewal === "true" || plan.isRenewal === "Yes")) ? (
                                                                                    <th >
                                                                                        Premiums per Unit
                                                                                    </th>
                                                                                ) : ('')}


                                                                                {(plan.planRateType !== "UnitBased" && (plan.isRenewal === "true" || plan.isRenewal === "Yes")) ? (
                                                                                    <th >
                                                                                        Future 100% Monthly Premium <br /> (exclude 2% admin fee)
                                                                                    </th>
                                                                                ) : ((plan.isRenewal !== "true" && plan.isRenewal !== "Yes") ? (
                                                                                    <th >
                                                                                        {plan.planRateType === "UnitBased" ? 'Premiums per Units' : (
                                                                                            <>
                                                                                                100% Monthly Premium
                                                                                                <br />
                                                                                                (exclude 2% admin fee)
                                                                                            </>
                                                                                        )}
                                                                                    </th>
                                                                                ) : (''))}




                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <th className="" scope="row">
                                                                                    Start Date
                                                                                </th>
                                                                                {(plan.isRenewal === "true" || plan.isRenewal === "Yes") && (
                                                                                    <td>{plan.currentRateStartDate ? format(new Date(plan.currentRateStartDate), 'MM/dd/yyyy') : '-'}</td>
                                                                                )}
                                                                                {(plan.planRateType !== "UnitBased" && (plan.isRenewal === "true" || plan.isRenewal === "Yes")) ? (
                                                                                    <td>{plan.futureRateStartDate ? format(new Date(plan.futureRateStartDate), 'MM/dd/yyyy') : '-'}</td>
                                                                                ) : ((plan.isRenewal !== "true" && plan.isRenewal !== "Yes") ? (
                                                                                    <td>{plan.futureRateStartDate ? format(new Date(plan.futureRateStartDate), 'MM/dd/yyyy') : '-'}</td>
                                                                                ) : (''))}
                                                                            </tr>

                                                                            <tr>
                                                                                <th className="" scope="row">
                                                                                    End Date
                                                                                </th>
                                                                                {(plan.isRenewal === "true" || plan.isRenewal === "Yes") && (
                                                                                    <td>{plan.currentRateEndDate ? format(new Date(plan.currentRateEndDate), 'MM/dd/yyyy') : '-'}</td>
                                                                                )}
                                                                                {(plan.planRateType !== "UnitBased" && (plan.isRenewal === "true" || plan.isRenewal === "Yes")) ? (
                                                                                    <td>{plan.futureRateEndDate ? format(new Date(plan.futureRateEndDate), 'MM/dd/yyyy') : '-'}</td>
                                                                                ) : ((plan.isRenewal !== "true" && plan.isRenewal !== "Yes") ? (
                                                                                    <td>{plan.futureRateEndDate ? format(new Date(plan.futureRateEndDate), 'MM/dd/yyyy') : '-'}</td>
                                                                                ) : (''))}
                                                                            </tr>
                                                                            <tr>
                                                                                <th className="" scope="row" style={{ backgroundColor: '#e9ecef' }}>{plan.planRateType === "UnitBased" ? 'Relationships' : 'Coverage Level'}</th>
                                                                                <td></td>
                                                                                <td></td>
                                                                            </tr>
                                                                            {plan[coverageType].map((coverage, idx) => (
                                                                                <tr key={idx}>
                                                                                    <th className="" scope="row">{coverage.coverageLevelName}</th>


                                                                                    {(plan.isRenewal === "true" || plan.isRenewal === "Yes") && (
                                                                                        <td><td>{`$${coverage.currentRate || 0.00}`}</td></td>

                                                                                    )}

                                                                                    {(plan.planRateType !== "UnitBased" && (plan.isRenewal === "true" || plan.isRenewal === "Yes")) ? (

                                                                                        <td>{`$${coverage.futureRate || 0.00}`}</td>
                                                                                    ) : ((plan.isRenewal !== "true" && plan.isRenewal !== "Yes") ? (
                                                                                        <td>{`$${coverage.futureRate || 0.00}`}</td>
                                                                                    ) : (''))}
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </>
                                                        )}

                                                        {(plan.planRateType === "Age/Banded" || plan.planRateType === "Unit + Age/Gender") && (

                                                            <>


                                                                <div className="row">
                                                                    <div className="col-lg-6">
                                                                        <h5 className="card-title mt-3">Rate Information</h5>
                                                                    </div>
                                                                </div>
                                                                <div className="table-responsive">
                                                                    <table className="styled-table table-hover mb-0">

                                                                        <tbody>
                                                                            <tr>
                                                                                <th>When should the premium update?</th>
                                                                                <td>
                                                                                    {
                                                                                        plan?.premiumUpdate === "dobOfCobraEnrollment" ? "DOB of COBRA Enrollment" :
                                                                                            plan?.premiumUpdate === "PlanAnniversary" ? "Plan Anniversary" :
                                                                                                plan?.premiumUpdate === "dob" ? "Date of Birth" :
                                                                                                    ""
                                                                                    }
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <th>Is there a cap for the number of dependents under the age of 20 for which the carrier bills?</th>

                                                                                <td>{plan?.isDEPCap ? "Yes" : "No"}</td>
                                                                            </tr>
                                                                            {plan?.isDEPCap && (
                                                                                <tr>
                                                                                    <th>If so, what is the cap?</th>
                                                                                    <td>{plan?.depCap}</td>
                                                                                </tr>

                                                                            )}

                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                            <Card.Body>
                                            </Card.Body>
                                        </Card>
                                    </Row>
                                </div>
                            </div>
                        </div>

                    ))}
                </Card.Body>
            </Card>
        </Col>
    );
}

export default PlanDetails;
